<template>
  <div class="club-card" :class="isPdf ? 'pdf-club-card' : 'mf-card'">
    <div class="left-side">
      <div class="big-number-section">
        <p class="big-number" :class="variant">{{ cardData.totalCoupons | localeString }}</p>
        <p class="big-number-label">{{ labels[0] }}</p>
      </div>
      <div class="big-number-section">
        <p class="big-number" :class="variant">{{ cardData.eligibleCoupons | localeString }}</p>
        <p class="big-number-label">{{ labels[1] }}</p>
      </div>
    </div>

    <div class="right-side">
      <apex-chart :height="isPdf ? '200' : '140'" width="100" :options="options" :series="series" />

      <div class="big-number-section">
        <p class="big-number" :class="variant">{{ (cardData.eligiblePercentageCoupons * 100) | localeString }}%</p>
        <p class="big-number-label">{{ labels[2] }}</p>
        <span v-if="!isPdf" class="link" @click="isOpen = true">O que significa esse número?</span>
      </div>
    </div>
    <club-card-dialog v-model="isOpen" :variant="variant" />
  </div>
</template>

<script>
import ClubCardDialog from './ClubCardDialog.vue'
import ApexChart from 'vue-apexcharts'
import { mapGetters } from 'vuex'
export default {
  name: 'ClubCard',
  components: { ApexChart, ClubCardDialog },
  props: {
    variant: {
      type: String,
      default: 'positive',
      validator: (value) => ['', 'positive', 'negative'].includes(value),
    },
    isPdf: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    ...mapGetters(['dreOffersCouponsMetrics']),
    cardData() {
      if (this.isEmpty(this.dreOffersCouponsMetrics)) {
        return {
          totalCoupons: 0,
          eligibleCoupons: 0,
          eligiblePercentageCoupons: 0,
        }
      } else {
        return this.variant === 'positive' ? this.dreOffersCouponsMetrics?.insideLoyaltyClub : this.dreOffersCouponsMetrics?.outsideLoyaltyClub
      }
    },
    series() {
      return [this.cardData.eligiblePercentageCoupons * 100]
    },
    options() {
      return {
        chart: {
          type: 'radialBar',
          toolbar: {
            show: false,
          },
        },
        states: {
          active: {
            filter: {
              type: 'none',
            },
          },
        },
        plotOptions: {
          radialBar: {
            offsetY: -25,
            hollow: {
              margin: 0,
              size: '20%',
            },
            track: {
              background: [`${this.variant === 'positive' ? '#00B3951A' : '#E032101A'}`],
            },
            dataLabels: {
              show: false,
            },
          },
        },
        fill: {
          colors: [`${this.variant === 'positive' ? '#00B395' : '#E03210'}`],
        },
        labels: [],
      }
    },
    labels() {
      const labels = {
        positive: ['Cupons do clube', 'Cupons do clube com oferta', 'dos cupons do clube, contém pelo menos uma oferta'],
        negative: ['Cupons não identificados', 'Cupons não identificados com oferta', 'dos cupons não identificados, contém produtos em oferta'],
      }

      return labels[this.variant]
    },
  },
  methods: {
    isEmpty(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false
      }

      return true
    },
  },
}
</script>

<style lang="scss" scoped>
.pdf-club-card {
  flex-direction: column;
  align-items: start !important;
  .right-side {
    .big-number-section {
      margin: 15px 0 0 10px;
      width: 60%;
    }
  }
}
.club-card {
  padding: 24px 40px 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left-side {
    :first-child {
      margin-bottom: 16px;
    }
    .big-number-section {
      .big-number,
      .big-number-label {
        margin-bottom: 0 !important;
      }
    }
  }
  .right-side {
    display: flex;
    align-content: flex-start;
    .big-number-section {
      .big-number {
        margin-bottom: 4px;
      }
      .big-number-label {
        font-size: 16px;
        margin-bottom: 12px;
      }
    }
  }
  .big-number {
    font-weight: 700;
    font-size: 22px;
    line-height: 26.4px;
  }
  .big-number-label {
    color: $cinza-l20;
    font-size: 14px;
    line-height: 20px;
  }
  .positive {
    color: $marca-1;
  }

  .negative {
    color: $vermelho-0;
  }
}
</style>
